export class PartV10 {
    static constructFromPlainObjectList(objList) {
        const partsList = [];
        if (objList && Array.isArray(objList)) {
            for (const obj of objList) {
                partsList.push(PartV10.constructFromPlainObject(obj));
            }
        }
        return partsList;
    }
    static constructFromPlainObject(obj) {
        const part = new PartV10(obj.mainGroup, obj.subgroup, obj.itemNumber, obj.description, obj.quantity, obj.invoiceTransparency, obj.clearingFlag, obj.coding, obj.comment, obj.absoluteDiscount, obj.isLocal, obj.hasRetentionRequirement, obj.reasonForRetentionRequirement, obj.price, obj.retailPrice, obj.split, obj.suffix, obj.valueAddedTaxInPercent, obj.vehicle);
        part.setPositionNumber(obj.positionNumber);
        part.setSelected(!!obj.selected);
        return part;
    }
    constructor(mainGroup, subgroup, itemNumber, description, quantity, invoiceTransparency, clearingFlag, coding, comment, absoluteDiscount, isLocal, hasRetentionRequirement, reasonForRetentionRequirement, price, retailPrice, split, suffix, valueAddedTaxInPercent, vehicle) {
        this.mainGroup = mainGroup;
        this.subgroup = subgroup;
        this.itemNumber = itemNumber;
        this.description = description;
        this.quantity = quantity;
        this.invoiceTransparency = invoiceTransparency;
        this.clearingFlag = clearingFlag;
        this.coding = coding;
        this.comment = comment;
        this.absoluteDiscount = absoluteDiscount;
        this.isLocal = isLocal;
        this.hasRetentionRequirement = hasRetentionRequirement;
        this.reasonForRetentionRequirement = reasonForRetentionRequirement;
        this.price = price;
        this.retailPrice = retailPrice;
        this.split = split;
        this.suffix = suffix;
        this.valueAddedTaxInPercent = valueAddedTaxInPercent;
        this.vehicle = vehicle;
        this.selected = false;
    }
    getInvoiceTransparency() {
        return this.invoiceTransparency;
    }
    setInvoiceTransparency(invoiceTransparency) {
        this.invoiceTransparency = invoiceTransparency;
    }
    getClearingFlag() {
        return this.clearingFlag;
    }
    getCoding() {
        return this.coding;
    }
    getComment() {
        return this.comment;
    }
    setComment(comment) {
        this.comment = comment;
    }
    getDescription() {
        return this.description;
    }
    setDescription(description) {
        this.description = description;
    }
    getAbsoluteDiscount() {
        return this.absoluteDiscount;
    }
    setAbsoluteDiscount(absoluteDiscount) {
        this.absoluteDiscount = absoluteDiscount;
    }
    getMainGroup() {
        return this.mainGroup;
    }
    getIsLocal() {
        return this.isLocal;
    }
    getNumber() {
        return this.mainGroup + this.subgroup + this.itemNumber;
    }
    getPositionNumber() {
        return this.positionNumber;
    }
    setPositionNumber(positionNumber) {
        this.positionNumber = positionNumber;
    }
    getHasRetentionRequirement() {
        return this.hasRetentionRequirement;
    }
    getReasonForRetentionRequirement() {
        return this.reasonForRetentionRequirement;
    }
    getPrice() {
        return this.price;
    }
    setPrice(price) {
        this.price = price;
    }
    getQuantity() {
        return this.quantity;
    }
    setQuantity(quantity) {
        this.quantity = quantity;
    }
    getRetailPrice() {
        return this.retailPrice;
    }
    getItemNumber() {
        return this.itemNumber;
    }
    getSplit() {
        return this.split;
    }
    setSplit(split) {
        this.split = split;
    }
    getSuffix() {
        return this.suffix;
    }
    setSuffix(suffix) {
        this.suffix = suffix;
    }
    getSubgroup() {
        return this.subgroup;
    }
    getValueAddedTaxInPercent() {
        return this.valueAddedTaxInPercent;
    }
    setValueAddedTaxInPercent(valueAddedTaxInPercent) {
        this.valueAddedTaxInPercent = valueAddedTaxInPercent;
    }
    getVehicle() {
        return this.vehicle;
    }
    isSelected() {
        return this.selected;
    }
    setSelected(selected) {
        this.selected = selected;
    }
}
//# sourceMappingURL=partV10.js.map